import { useState } from 'react';

import { GridFilterModel, GridPaginationModel } from '@mui/x-data-grid';

import { useGetAllNewsPosts } from 'src/api/hooks/api-hooks';

interface Props {
  newsPostsPerPage?: number;
  initialPaginationModel?: GridPaginationModel;
}

export function useNewsPostsList(props?: Props) {
  const { newsPostsPerPage, initialPaginationModel } = props ?? {};

  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>(
    initialPaginationModel ?? {
      pageSize: newsPostsPerPage ?? 25,
      page: 0,
    }
  );

  const [filterModel, setFilterModel] = useState<GridFilterModel>();
  const {
    data: newsPostsResponse,
    isLoading: loadingNewsPosts,
    error,
  } = useGetAllNewsPosts(paginationModel);

  return {
    newsPosts: newsPostsResponse?.data ?? [],
    newsPostsTotalCount: newsPostsResponse?.totalRecords,
    newsPostsTotalPages: newsPostsResponse?.totalPages,

    fetchNewsPostsLoading: loadingNewsPosts,
    fetchNewsPostsError: error,

    paginationModel,

    filterModel,

    fetchNewsPosts: fetch,
    setFilterModel,
    setPaginationModel,
  };
}
